const COUPON_STATUS = {
  ACTIVE: 1,
  USED: 2,
  EXPIRED: 3,
};

export default COUPON_STATUS;
